export default "/images/vendor/flag-icons/flags/1x1/cp.svg?6c0badecbaa751338752a1872581cd61";